import { Record, List, Map } from 'immutable';
import { actions } from '../constants';

const initialState = new Record({
  loading: false,
  error: null,
  patientsById: Map(),
  pendingPatients: List()
})();

export default function patientReducer(state = initialState, action = null) {
  const { type, payload } = action;
  switch (type) {
    case actions.PATIENT_LIST_REQUESTED:
      return state.merge({
        loading: true,
        error: null
      });
    case actions.PATIENT_LIST_RECEIVED:
      const byId = payload.patients
        .filter((p) => !!p.get('id'))
        .reduce((byId, p) => {
          const existing = state.patientsById.get(p.get('id'));
          if ( existing ) {
            return byId.set(p.get('id'), existing.set('patient',
                                                      p.merge(existing.get('patient'))
                                                     ));
          }
          return byId.set(p.get('id'), Map({ patient: p,
                                             loading: false,
                                             loaded: false,
                                             error: null }));
        }, Map());
      const pending = payload.patients.filter((p) => !p.get('id'));
      
      return state.merge({
        loading: false,
        pendingPatients: pending,
        patientsById: byId,
        error: null
      });
    case actions.PATIENT_LIST_REQUEST_FAILED:
      return state.merge({
        loading: false,
        error: payload.error
      });
    case actions.PATIENT_REQUESTED:
      const patientId = +payload.patientId;
      return state.merge({
        patientsById: state.patientsById.setIn([ patientId, 'loading' ], true)
      });
    case actions.PATIENT_RECEIVED:
      const id = +payload.patient.get('id');
      return state.merge({
        patientsById: state.patientsById
          .setIn([ id, 'patient'], payload.patient)
          .setIn([ id, 'loaded' ], true)
          .setIn([ id, 'loading' ], false)
          .setIn([ id, 'error' ], null)
      });
    case actions.PATIENT_REQUEST_FAILED:
      const pId = +payload.patientId;
      return state.merge({
        patientsById: state.patientsById
          .setIn([ pId, 'error' ], payload.error)
          .setIn([ pId, 'loading' ], false)
      });
    case actions.EMAIL_ACCESS_CODE_SENT:
    case actions.SMS_ACCESS_CODE_SENT:
      return state.merge({
        pendingPatients: state.pendingPatients.unshift(payload.invite)
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/patient-list.js